import moment from 'moment'

export function getNextMonth(date: Date) {
  var nextMonth
  var month = date.getMonth()

  if (month === 11) {
    nextMonth = new Date(date.getFullYear() + 1, 0, 2)
  } else {
    nextMonth = new Date(date.getFullYear(), month + 1, 2)
  }
  return nextMonth
}

export function roundToNextDate() {
  const start = moment()
  const remainder = 15 - (start.minute() % 15)

  const dateTime = moment(start).add(remainder, 'minutes')
  return dateTime.toDate()
}

export function formatAMPM(date: any) {
  var hours = date.getHours()
  var minutes = date.getMinutes()
  var ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes
  var strTime = hours + ':' + minutes + ' ' + ampm
  return strTime
}

export function didDatePass(date: Date) {
  return new Date().toISOString().slice(0, 10) > date.toISOString().slice(0, 10)
}

export function getTimeStampInSeconds(date: Date) {
  return Math.floor(date.getTime() / 1000)
}

const { imperial } = (window as any).config

export class DateUtil {
  public static getFormatDateSimple() {
    let dateFormat

    if (imperial) dateFormat = 'MM/DD/YYYY'
    else dateFormat = 'DD/MM/YYYY'

    return dateFormat
  }

  public static getFormatDayMonth() {
    let dateFormat

    if (imperial) dateFormat = 'MM/DD'
    else dateFormat = 'DD/MM'

    return dateFormat
  }

  public static getFormatHour() {
    let dateFormat

    if (imperial) dateFormat = 'h:mm A'
    else dateFormat = 'H:mm'

    return dateFormat
  }

  public static getFormatDateHour() {
    let dateFormat = DateUtil.getFormatDateSimple() + ' ' + DateUtil.getFormatHour()

    return dateFormat
  }

  public static getForLibraryFormatHour() {
    let dateFormat

    if (imperial) dateFormat = 'hh:mm a'
    else dateFormat = 'HH:mm'

    return dateFormat
  }

  public static getForLibraryFormatFormatDateSimple() {
    let dateFormat

    if (imperial) dateFormat = 'MM/dd/yyyy'
    else dateFormat = 'dd/MM/yyyy'

    return dateFormat
  }

  public static getForLibraryFormatDateHour() {
    let dateFormat =
      DateUtil.getForLibraryFormatFormatDateSimple() + ' ' + DateUtil.getForLibraryFormatHour()

    return dateFormat
  }

  public static getMomentFormatDateOrHourIfNow(momentInput: moment.MomentInput) {
    let momemtFormat, formatFinal

    const isSameDay = moment(momentInput).isSame(moment(), 'day')

    if (isSameDay) formatFinal = DateUtil.getFormatHour()
    else formatFinal = DateUtil.getFormatDateHour()

    momemtFormat = moment(momentInput).format(formatFinal)

    return momemtFormat
  }
}
